import { parseDate, dateDiff, now } from 'shared-components';

export const UNKNOWN_VALUE = 'Unknown';

export function getDays(stageChangeDate: string | undefined): string {
  if (!stageChangeDate || stageChangeDate === '-') {
    return UNKNOWN_VALUE;
  }
  const currentDate = now();
  const parsedStageChangeDate = parseDate(stageChangeDate);
  if (!stageChangeDate) {
    return UNKNOWN_VALUE;
  }
  const days = dateDiff(parsedStageChangeDate, currentDate, 'days');
  if (isNaN(days) || days < 0) {
    return UNKNOWN_VALUE;
  }
  const dayString = String(days);
  if (['', '-'].includes(dayString)) {
    return UNKNOWN_VALUE;
  }
  if (['1'].includes(dayString)) {
    return '1 day';
  }
  return `${dayString} days`;
}
